class FeaturePills extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll('.pill-btn');
    const lists = this.querySelectorAll('.pill-list');
    const images = this.querySelectorAll('.pill-img');

    const activate = (id) => {
      // buttons
      buttons.forEach(b => b.classList.toggle('active', b.dataset.target === id));
      // lists
      lists.forEach(l => l.classList.toggle('active', l.id === `pill-list-${id}`));
      // images
      images.forEach(img => img.classList.toggle('active', img.id === `pill-image-${id}`));
    };

    buttons.forEach(btn => {
      btn.addEventListener('click', () => activate(btn.dataset.target));
    });
  }
}
if (!customElements.get('feature-pills')) {
  customElements.define('feature-pills', FeaturePills);
}
